import { createFileRoute } from "@tanstack/react-router";
import { HomePage } from "@corpuscomplete/web/modules/home/pages/home";

export const Route = createFileRoute("/_authenticated/home")({
  component: HomePage,
});
